import React, { useEffect, useState } from "react";
import { useNotifications } from "./useNotificactions";
import { playNotificationSound } from "./useUnlockAudio";
import { startTabAlert, stopTabAlert } from "./TabAlertManager";
import { ChatScreen } from "../Screens/Whatsapp/ChatScreen";

export default function NotificationModal() {
  const {
    activeNotification,
    resolveNotification,
    cargarModuloUsuario,
    atendiendo,
    marcarAtendiendo,
    queue,
  } = useNotifications();
  const [chatAbierto, setChatAbierto] = useState(false);
  const [chatData, setChatData] = useState(null);

  // si ya se estaba atendiendo (por ejemplo tras recargar la página),
  // reabrir el chat automáticamente para que se pueda responder
  useEffect(() => {
    if (activeNotification && atendiendo && !chatAbierto) {
      abrirChat();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeNotification, atendiendo]);

  function showNotification(data) {
    const notificacion = new Notification("Humaya Digital", {
      body: data.message,
      icon: "/static/media/imagenes/logomaquinaria.jpeg",
      image: "/static/media/imagenes/logo-2.png",
      badge: "/static/media/imagenes/logo-2.png",
      tag: "NotificacionesHD",
      renotify: true,
      requireInteraction: true,
      data: data,
    });
    notificacion.onclick = (e) => {
      window.focus();
      handleResolve();
      // console.log(e.data)

    };
    notificacion.onclose = (e) => {
      if (!e) return;
      const info = e.target.data;
      // setTimeout(() => {
      //   showNotification(info);
      // }, 3000);
    };
  }
  useEffect(() => {
    if (activeNotification) {

      // reproducir sonido
      playNotificationSound();
      startTabAlert("Nuevo Mensaje", queue.length);

      // notificación del sistema si la pestaña no está visible
      if (document.hidden && Notification.permission === "granted") {
        showNotification(activeNotification);
      }
    }
  }, [activeNotification, queue]);

  // useEffect(() => {
  //   if (activeNotification) {
  //     startTabAlert("Nuevo Mensaje", queue.length);
  //   }
  // }, [activeNotification, queue]);

  useEffect(() => {
    const handVisibility = () => {
      if (!document.hidden) {
        stopTabAlert();
      }
    };

    document.addEventListener("visibilitychange", handVisibility);
    return () => {
      document.removeEventListener("visibilitychange", handVisibility);
    };
  }, []);

  // if (!activeNotification) return null;



  const abrirChat = async () => {
    stopTabAlert();

    const modulo = await cargarModuloUsuario();

    setChatData({
      ...activeNotification?.data,
      modulo: modulo,
    });

    setChatAbierto(true);
    marcarAtendiendo();
  };

  const handleResolve = () => {
    abrirChat();
  };

  // solo se libera la notificación hasta que se envía una respuesta en el chat
  const handleMensajeEnviado = () => {
    setChatAbierto(false);
    setChatData(null);
    resolveNotification();
  };

  // console.log(chatData)
  return (
    <>
      {activeNotification && !chatAbierto && (
        <div style={overlay}>
          <div style={modal}>
            <div style={header}>
              <div style={icon}>🔔</div>
              <div>
                <div style={title}>Nueva notificación</div>
                <div style={subtitle}>Mensaje entrante</div>
              </div>
            </div>

            <div style={body}>
              {activeNotification.message}
            </div>

            <div style={buttonContainer}>
              <button style={primaryBtn} onClick={handleResolve}>
                Atender
              </button>
            </div>
          </div>
        </div>
      )}

      {activeNotification && (
        <ChatScreen
          open={chatAbierto}
          onClose={() => {}}
          numeroTelefono={chatData?.numeroTelefono}
          cliente={chatData?.cliente}
          modulo={chatData?.modulo}
          onMensajeEnviado={handleMensajeEnviado}
        />
      )}
    </>
  );
}

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 99999,
};

const modal = {
  background: "#fff",
  borderRadius: "16px",
  width: "380px",
  padding: "24px",
  boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
  animation: "fadeIn 0.2s ease",
};

const header = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  marginBottom: "16px",
};

const icon = {
  fontSize: "28px",
  background: "#e3f2fd",
  padding: "10px",
  borderRadius: "50%",
};

const title = {
  fontSize: "18px",
  fontWeight: "600",
  color: "#333",
};

const subtitle = {
  fontSize: "13px",
  color: "#888",
};

const body = {
  fontSize: "15px",
  color: "#444",
  marginBottom: "20px",
  lineHeight: "1.5",
  background: "#f5f5f5",
  padding: "12px",
  borderRadius: "8px",
};

const buttonContainer = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
};

const primaryBtn = {
  padding: "10px 18px",
  background: "#035917",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "500",
  transition: "all 0.2s ease",
};

const secondaryBtn = {
  padding: "10px 18px",
  background: "#eee",
  color: "#555",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "500",
};

// import React from "react";
// import { useNotifications } from "./useNotificactions";

// export default function NotificationModal() {

//   const { activeNotification, resolveNotification } = useNotifications();

//   if (!activeNotification) return null;

//   return (
//     <div style={overlay}>
//       <div style={modal}>

//         <h2>🔔 Nueva alerta</h2>

//         <p>{activeNotification.message}</p>

//         <div style={{ marginTop: 20 }}>

//           <button onClick={resolveNotification}>
//             Atender
//           </button>

//         </div>

//       </div>
//     </div>
//   );
// }

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100vw",
//   height: "100vh",
//   background: "rgba(0,0,0,0.5)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   zIndex: 99999
// };

// const modal = {
//   background: "white",
//   padding: "30px",
//   borderRadius: "10px",
//   width: "400px",
//   textAlign: "center"
// };
